import HomePage from 'pages/home'
import LiveDetailPage from 'pages/live-detail'
import { Route, Switch } from 'react-router-dom'
//import { Redirect, Route, Switch } from 'react-router-dom'

const Routes = () => {
  return (
    <Switch>
      <Route exact path="/" component={HomePage} />
      <Route exact path="/live/:liveId" component={LiveDetailPage} />
      <Route exact path="/wec" component={HomePage} />
      <Route exact path="/wec/live/:liveId" component={LiveDetailPage} />
    </Switch>
  )
}

export default Routes
